"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorButton = void 0;
var React = require("react");
var recompose_1 = require("recompose");
var classNames = require("classnames");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
require("./style.scss");
var Component = function (props) { return (React.createElement("div", { className: classNames('sok-generic-error-message', props.className) },
    props.icon,
    React.createElement("p", null, typeof props.title === 'function' ? props.title() : props.title),
    props.text && React.createElement("span", { className: 'text' }, props.text),
    props.children)); };
exports.default = (0, recompose_1.defaultProps)({
    icon: React.createElement("img", { src: '/assets/machinery/excavator-drill.svg' }),
    title: function () { return (0, translation_1.getLocalization)('generic/error'); },
    text: undefined
})(Component);
var ErrorComponent = function (props) { return (React.createElement("p", { className: props.onClick ? 'error-button' : '', onClick: props.onClick }, props.children)); };
var DefaultError = function () { return React.createElement("span", null, (0, translation_1.getLocalization)('generic/tryAgain')); };
exports.ErrorButton = (0, recompose_1.defaultProps)({
    onClick: undefined,
    children: React.createElement(DefaultError, null)
})(ErrorComponent);
